export default __webpack_public_path__ + "static/media/snowuns-characters.722244d6.png";